import axios from "axios";
import axiosInstance from "../../../../Utils/axios";
import { paginationQueryParams } from "../../../../Utils/paginationParam";
let cancelToken;

const accountGroupModURL = "api/v1/account-app/glaccount-group";
//obtaining the paginated data
export const getAccountGroup = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();

  return axiosInstance.get(
    `${accountGroupModURL}/list?${paginationQueryParams(rowsPerPage, search, sortOrder, pageNo)}`,
    {
      cancelToken: cancelToken.token,
    }
  );
};

//obtaining all fiscal sessions
export const getAllAccountGroup = () => axiosInstance.get(`${accountGroupModURL}/list?ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPageAccountGroup = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(`${accountGroupModURL}/list?${paginationQueryParams(rowsPerPage, search, "", number)}`);

//creating function
export const createAccountGroup = (body) => axiosInstance.post(`${accountGroupModURL}/create`, body);
//updating function
export const updateAccountGroup = (id, body) => axiosInstance.patch(`${accountGroupModURL}/update/${id}`, body);

//get accountGroup by id
export const getAccountGroupById = (id) => axiosInstance.get(`${accountGroupModURL}/retrieve/${id}`);

//searching function
export const handleSearch = ({ search, rowsPerPage, sortOrder }) =>
  axiosInstance.get(`${accountGroupModURL}/list?offset=0&limit=${rowsPerPage}&ordering=${sortOrder}&search=${search}`);

// checking the redundant data
export const checkRedundantDataAccountGroupName = (e, cancelToken) =>
  axiosInstance.get(`${accountGroupModURL}/list?name=${e.target.value.trim()}`, {
    cancelToken: cancelToken.token,
  });
